import React from "react";
import Appear from "../appear";
import Footer from "../global/footer";
import Header from "../global/header";

const V00Appear = ({header, footer}) => {
  const {menuv0} = footer;

  return (
    <>
     <Header header={header} />
      <Appear isBg="yes" />
      <Footer  isBg="" menu={menuv0} />
    </>
  );
}

export default V00Appear;
